var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.userAreaIsGarantia)?_c('QuotationListGarantia'):_vm._e(),(_vm.userAreaIsAgro)?_c('QuotationListAgro'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }